import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

const NAV_MOBILE_BREAKPOINT = 768;

const NavigationBar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= NAV_MOBILE_BREAKPOINT,
  );
  const dropdownRefs = useRef({});

  const toggleDropdown = (menu) => {
    setOpenDropdown((prev) => (prev === menu ? null : menu));
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= NAV_MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) {
        setMenuOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !Object.values(dropdownRefs.current).some(
          (ref) => ref && ref.contains(event.target),
        )
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navLinkStyle = () => ({
    color: "black",
    textDecoration: "none",
  });

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const navStyle = {
    display: isMobile ? (menuOpen ? "flex" : "none") : "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "flex-start" : "center",
    flexWrap: "wrap",
    gap: "1.5rem",
    backgroundColor: "white",
    position: "relative",
    width: "100%",
    letterSpacing: "0.2rem",
    fontFamily: '"Open Sans", arial, sans-serif',
    fontWeight: 200,
    padding: isMobile ? "1rem 1.25rem" : "0rem 1rem 2rem",
    justifyContent: "center",
    textAlign: "left",
  };

  const handleDesktopEnter = (menu) => {
    if (!isMobile) setOpenDropdown(menu);
  };

  const handleDesktopLeave = () => {
    if (!isMobile) setOpenDropdown(null);
  };

  return (
    <>
      {isMobile && (
        <div
          className="site-nav-toggle-wrap"
          style={{
            padding: "1rem 1.25rem",
            backgroundColor: "white",
            textAlign: "left",
          }}
        >
          <button
            type="button"
            className="site-nav-toggle"
            onClick={toggleMenu}
            aria-expanded={menuOpen}
            style={{
              fontSize: "1.75rem",
              fontFamily: '"Open Sans", arial, sans-serif',
              letterSpacing: "0.2rem",
              color: "#5a5a5a",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 0,
            }}
          >
            {menuOpen ? "✕ Close" : "☰ Menu"}
          </button>
        </div>
      )}

      <nav style={navStyle} className="site-nav">
        <div style={{ position: "relative" }}>
          <NavLink className="site-nav__link" style={navLinkStyle} to="/" end>
            HOME
          </NavLink>
        </div>
        <div
          className={`site-nav__dropdown ${
            openDropdown === "Meet the Team" ? "is-open" : ""
          }`}
          style={{ position: "relative" }}
          ref={(el) => (dropdownRefs.current["Meet the Team"] = el)}
          onMouseEnter={() => handleDesktopEnter("Meet the Team")}
          onMouseLeave={handleDesktopLeave}
        >
          <button
            type="button"
            className="site-nav__dropdown-trigger"
            onClick={() => toggleDropdown("Meet the Team")}
            aria-expanded={openDropdown === "Meet the Team"}
            style={{
              cursor: "pointer",
              background: "none",
              border: "none",
              font: "inherit",
              letterSpacing: "inherit",
              color: "inherit",
              padding: 0,
            }}
          >
            MEET THE TEAM
            <span className="site-nav__chevron" aria-hidden="true" />
          </button>
          <div
            className={`site-nav__dropdown-menu ${
              openDropdown === "Meet the Team" ? "open" : ""
            }`}
          >
            <NavLink style={navLinkStyle} to="/meet-the-founder">
              Meet the Founder
            </NavLink>
            <NavLink style={navLinkStyle} to="/meet-the-agents">
              Meet the Agents
            </NavLink>
          </div>
        </div>
        <div
          className={`site-nav__dropdown ${
            openDropdown === "Product" ? "is-open" : ""
          }`}
          style={{ position: "relative" }}
          ref={(el) => (dropdownRefs.current["Product"] = el)}
          onMouseEnter={() => handleDesktopEnter("Product")}
          onMouseLeave={handleDesktopLeave}
        >
          <button
            type="button"
            className="site-nav__dropdown-trigger"
            onClick={() => toggleDropdown("Product")}
            aria-expanded={openDropdown === "Product"}
            style={{
              cursor: "pointer",
              background: "none",
              border: "none",
              font: "inherit",
              letterSpacing: "inherit",
              color: "inherit",
              padding: 0,
            }}
          >
            PRODUCTS &amp; SERVICES
            <span className="site-nav__chevron" aria-hidden="true" />
          </button>
          <div
            className={`site-nav__dropdown-menu ${
              openDropdown === "Product" ? "open" : ""
            }`}
          >
            <NavLink style={navLinkStyle} to="/health-insurance-101">
              Health Insurance 101
            </NavLink>
            <NavLink style={navLinkStyle} to="/individual-family-plans">
              Individual &amp; Family Plans
            </NavLink>
            <NavLink style={navLinkStyle} to="/medicare-plans">
              Medicare Plans
            </NavLink>
            <NavLink style={navLinkStyle} to="/employer-sponsored-plans">
              Employer - Sponsored Plans
            </NavLink>
            <NavLink style={navLinkStyle} to="/final-expense-plans">
              Final Expense Plans
            </NavLink>
          </div>
        </div>
        <div style={{ position: "relative" }}>
          <NavLink
            className="site-nav__link"
            style={navLinkStyle}
            to="/testimonials"
          >
            TESTIMONIALS
          </NavLink>
        </div>
        <div style={{ position: "relative" }}>
          <NavLink className="site-nav__link" style={navLinkStyle} to="/faq">
            FAQ
          </NavLink>
        </div>
        <div style={{ position: "relative" }}>
          <NavLink
            className="site-nav__link"
            style={navLinkStyle}
            to="/become-an-agent"
          >
            BECOME AN AGENT
          </NavLink>
        </div>
        <div style={{ position: "relative" }}>
          <NavLink
            className="site-nav__link"
            style={navLinkStyle}
            to="/contact-us"
          >
            CONTACT US
          </NavLink>
        </div>
      </nav>
    </>
  );
};

export default NavigationBar;
